import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = ({ setUser }) => {
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    processAuth();
  }, []);

  const processAuth = async () => {
    // Get session_id from URL fragment
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const sessionId = params.get('session_id');

    if (!sessionId) {
      toast.error('Authentication failed');
      navigate('/');
      return;
    }

    try {
      const response = await axios.post(
        `${API}/auth/session`,
        {},
        {
          headers: { 'X-Session-ID': sessionId },
          withCredentials: true
        }
      );

      setUser(response.data.user);
      toast.success(`Welcome back, ${response.data.user.name}!`);
      
      // Clean URL
      window.history.replaceState({}, document.title, '/dashboard');
      navigate('/dashboard');
    } catch (error) {
      console.error('Auth error:', error);
      toast.error('Authentication failed');
      navigate('/');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 to-orange-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-orange-600 mx-auto mb-4"></div>
        <p className="text-gray-600 text-lg">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;